/**
 * Loading Spinner Component
 *
 * Reusable loading indicator - shared across Metlas apps
 */

import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'medium', message }) => {
  return (
    <div className="loading-spinner-container">
      <div className={`loading-spinner ${size}`} />
      {message && <p className="loading-spinner-message">{message}</p>}
    </div>
  );
};
